import React from "react";
import { useWorkflowExecution } from "../../../../context/WorkflowExecutionContext";
import { useWorkflow } from "../../../../context/WorkflowContext";
import DataViewer from "./DataViewer";

export default function OutputTab({ step }) {
    const { steps } = useWorkflow();
    const { stepExecutionResult, stepExecutionLogs } = useWorkflowExecution();

    const stepIndex = steps.findIndex((s) => s.id === step.id);
    let outputData = null;
    let duration = null;

    if (stepExecutionResult && stepIndex >= 0 && stepExecutionResult[stepIndex]) {
        const result = stepExecutionResult[stepIndex];
        outputData = result?.output || result?.result || result;
        duration = result?.duration || null;
    }

    const logs = stepExecutionLogs?.[step.id];
    const itemCount = Array.isArray(outputData) ? outputData.length : outputData ? 1 : null;

    return (
        <div className="flex flex-col h-full">
            <DataViewer data={outputData} label="output data" itemCount={itemCount} duration={duration} />
            {logs && (
                <div className="border-t border-gray-200 px-4 py-2">
                    <div className="text-xs text-gray-500 font-medium mb-1">Logs</div>
                    <pre className="text-[10px] font-mono text-gray-600 whitespace-pre-wrap max-h-[120px] overflow-y-auto bg-gray-50 rounded p-2">
                        {typeof logs === "string" ? logs : JSON.stringify(logs, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
}
